module.exports = __webpack_public_path__ + "static/img/sub_page_banner_5.15ea95e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_5.jpg
// module id = n7k0
// module chunks = 0